import {PUBLIC_ACTION_TYPES} from "@store/actionTypes/PublicActionTypes"

const initialState = {
    getCountryLoading: false,
    getCountryData: null,
    getCountryError: null,

    getRegionLoading: false,
    getRegionData: null,
    getRegionError: null,

    getStateLoading: false,
    getStateData: null,
    getStateError: null,

    getCityLoading: false,
    getCityData: null,
    getCityError: null,

    getGoalAttrLoading: false,
    getGoalAttrData: null,
    getGoalAttrError: null,
}

const publicReducer = (state = initialState, action) => {
    switch (action.type) {
        case PUBLIC_ACTION_TYPES.GET_COUNTRY_REQUEST:
            return {
                ...state,
                getCountryLoading: true,
                getCountryData: null,
                getCountryError: null
            }
        case PUBLIC_ACTION_TYPES.GET_COUNTRY_DATA:
            return {
                ...state,
                getCountryLoading: false,
                getCountryData: action.payload,
                getCountryError: null
            }
        case PUBLIC_ACTION_TYPES.GET_COUNTRY_ERROR:
            return {
                ...state,
                getCountryLoading: false,
                getCountryData: null,
                getCountryError: action.payload
            }

        case PUBLIC_ACTION_TYPES.GET_REGION_REQUEST:
            return {
                ...state,
                getRegionLoading: true,
                getRegionData: null,
                getRegionError: null
            }
        case PUBLIC_ACTION_TYPES.GET_REGION_DATA:
            return {
                ...state,
                getRegionLoading: false,
                getRegionData: action.payload,
                getRegionError: null
            }
        case PUBLIC_ACTION_TYPES.GET_REGION_ERROR:
            return {
                ...state,
                getRegionLoading: false,
                getRegionData: null,
                getRegionError: action.payload
            }
        case PUBLIC_ACTION_TYPES.GET_REGION_RESET:
            return {
                ...state,
                getRegionLoading: false,
                getRegionData: null,
                getRegionError: null
            }

        case PUBLIC_ACTION_TYPES.GET_STATE_REQUEST:
            return {
                ...state,
                getStateLoading: true,
                getStateData: null,
                getStateError: null
            }
        case PUBLIC_ACTION_TYPES.GET_STATE_DATA:
            return {
                ...state,
                getStateLoading: false,
                getStateData: action.payload,
                getStateError: null
            }
        case PUBLIC_ACTION_TYPES.GET_STATE_ERROR:
            return {
                ...state,
                getStateLoading: false,
                getStateData: null,
                getStateError: action.payload
            }
        case PUBLIC_ACTION_TYPES.GET_STATE_RESET:
            return {
                ...state,
                getStateLoading: false,
                getStateData: null,
                getStateError: null
            }

        case PUBLIC_ACTION_TYPES.GET_CITY_REQUEST:
            return {
                ...state,
                getCityLoading: true,
                getCityData: null,
                getCityError: null
            }
        case PUBLIC_ACTION_TYPES.GET_CITY_DATA:
            return {
                ...state,
                getCityLoading: false,
                getCityData: action.payload,
                getCityError: null
            }
        case PUBLIC_ACTION_TYPES.GET_CITY_ERROR:
            return {
                ...state,
                getCityLoading: false,
                getCityData: null,
                getCityError: action.payload
            }
        case PUBLIC_ACTION_TYPES.GET_CITY_RESET:
            return {
                ...state,
                getCityLoading: false,
                getCityData: null,
                getCityError: null
            }

        case PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_REQUEST:
            return {
                ...state,
                getGoalAttrLoading: true,
                getGoalAttrData: null,
                getGoalAttrError: null
            }
        case PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_DATA:
            return {
                ...state,
                getGoalAttrLoading: false,
                getGoalAttrData: action.payload,
                getGoalAttrError: null
            }
        case PUBLIC_ACTION_TYPES.GET_GOAL_ATTR_ERROR:
            return {
                ...state,
                getGoalAttrLoading: false,
                getGoalAttrData: null,
                getGoalAttrError: action.payload
            }

        default:
            return state
    }
}

export default publicReducer